<template>
    <div class="indented">
      <form @submit.prevent="submitForm" ref="formHTML">
        <h3>Add Root Node</h3>
        <hr />
        <div class="form-horizontal">
          <h5>Enter name of category you want to add the root node for:</h5>
          <div class="spacer"></div>
          <div class="form-group spaced">
            Root node category name:
            <div class="spacer"></div>
            <div class="col-md-10">
              <input type="text" name="catname" v-model="catname" required class="form-control" />
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-10">
              <input type="submit" v-show="catname" value="Add" class="button btn btn-default" />
            </div>
          </div>
        </div>
      </form>
    </div>
</template>

<script>
  import axios from 'axios';
  import qs from 'qs'; // qs was installed from command prompt with npm install qs
  export default {
    name: 'Comp_AddRootNode',
    props: [],
    data() {
      return {
        form: {},
        catname: null
      }
    },
    methods: {
      submitForm() {
        const body = {
          "subcatname": this.catname,
          "parentid": 0,
          "level": 0
        }
        const url = 'https://api-japie.top/meubels/addsubcat';
        let options = {
          method: 'POST',
          headers: { 'content-type': 'application/x-www-form-urlencoded' },
          data: qs.stringify(body),
          url
        };
        axios(options).then(response => {
          this.$emit('reloadtreeview');
        })
          .catch(err => {
            alert(err);
          });
      }
    }
  }
</script>


<style scoped src="bootstrap/dist/css/bootstrap.min.css">

  /* install bootstrap first by typing 'npm install bootstrap' in command prompt */
</style>

<style scoped>

  .indented {
    margin: 20px;
    max-width: 550px;
  }

  .spacer {
    height: 15px;
    border: 0px solid black;
  }

  .spaced {
    margin-bottom: 10px;
  }

  .button {
    border: 1px solid gray;
  }
</style>



// WEBPACK FOOTER //
// src/Comp_AddRootNode.vue